module.exports = __webpack_public_path__ + "static/media/react1ArrowFunction.af280a7c.png";